import React, { useState, useRef, useEffect } from "react";
import { func, string, bool, object, array } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import HamburgerIcon from "../../../atoms/icons/hamburger";
import SearchIcon from "../../../atoms/icons/search-icon";
import NavbarSearch from "../NavbarSearch";
import { logoRenderer, useDeviceWidth } from "../../../utils/react-utils";
import { micrositeStyles } from "./header-utils";
import { getDateFromUtils } from "../../../utils/utils";
import { staticTexts } from "../../../utils/Translate";
import DesktopLogo from "../../../atoms/DesktopLogo";
import Dropdown from "../../../atoms/Dropdown";
import { listValue } from "../../../utils/constant";
import Navbar from "../Navbar";
import Headroom from "./Headroomindex";

import "./staticHeader.m.css";
import LoginContainer from "./LoginContainer";

const StaticHeader = ({
  toggleVerticalMenubar,
  isVerticalMenubar,
  publisherAttributes,
  dot,
  toggleNotifications,
  showNotifications,
  originalLocation,
  notifications,
  domainMenuItemsObj,
  location,
  domainSlug,
  pageType,
}) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const [domainStyle, setDomainStyle] = useState({});
  const [showSearchIcon, setShowSearchIcon] = useState(true);
  const [sticky, setSticky] = useState(false);
  const ref = useRef(null);
  const scrollRef = useRef(null);

  useDeviceWidth(setIsDesktop);

  useEffect(() => {
    if (domainSlug) {
      setDomainData(domainSlug);
    }
  }, [domainSlug]);

  const setDomainData = (domainName) => {
    setDomainStyle(micrositeStyles[domainName] || {});
  };

  useEffect(() => {
    const handleScroll = () => {
      const navbarTopDistance = Math.abs(scrollRef.current.getBoundingClientRect().top);
      navbarTopDistance < 107 ? setSticky(false) : setSticky(true);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.addEventListener("scroll", handleScroll);
  }, []);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setShowSearchIcon(true);
    }
  };

  useEffect(() => {
    !showSearchIcon && toggleSearchIcon();
  }, [sticky]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    document.addEventListener("scroll", () => setShowSearchIcon(true));
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
      document.removeEventListener("scroll", () => setShowSearchIcon(true));
      !showSearchIcon && toggleSearchIcon();
    };
  });

  const toggleSearchIcon = () => setShowSearchIcon(!showSearchIcon);

  const menuItemsObject =
    domainMenuItemsObj.length > 0
      ? {
          homePageMenuItems: domainMenuItemsObj.find((item) => item.title === "home" || item.title === "Home"),
          hamburgerMenuItems: domainMenuItemsObj.find((item) => item.title === "hamburger"),
        }
      : null;

  const homePageMenuItems = get(menuItemsObject, ["homePageMenuItems", "children"], []);

  // const multiDomainWrapperName = (location) => {
  //   return location ? location + "-wrapper" : "wrapper";
  // };

  let showNotification = false;
  if (originalLocation !== "auth.prothomalo.com" && (location === "bn" || publisherAttributes.lang === "en")) {
    showNotification = true;
  }

  return (
    <div styleName="base" className={`${sticky ? "sticky-palo-navbar" : ""}`} ref={scrollRef}>
      <Headroom>
        <div styleName="header-wrapper" className="logo-ham-search">
          <div styleName="hamburger-search-wrapper" className="hamburger-search-wrapper">
            <div styleName="search-ham" className="search-ham">
              <HamburgerIcon
                onMenuToggle={toggleVerticalMenubar}
                isNavbarOpen={isVerticalMenubar}
                isDesktop={isDesktop}
                datatrackingcategory="Button"
                datatrackingaction="Click"
                datatrackinglabel="হ্যামবার্গার বাটন"
              />
              <>
                {showSearchIcon && (
                  <span className="search-icon-wrapper" styleName="search-icon" onClick={toggleSearchIcon}>
                    <SearchIcon color={domainStyle.searchColor} />
                  </span>
                )}
                <span ref={ref} styleName={!showSearchIcon ? "navbar-search" : ""}>
                  {!showSearchIcon && <NavbarSearch publisherAttributes={publisherAttributes} />}
                </span>
              </>
            </div>
            <time styleName={`date`}>{getDateFromUtils(publisherAttributes.lang)}</time>
          </div>
          <div styleName={`logo ${isVerticalMenubar ? "vertical-menu-bar-logo" : ""}`}>
            {logoRenderer(
              <DesktopLogo
                location={location}
                lang={publisherAttributes.lang}
                datatrackingcategory="Logo"
                datatrackingaction="Click"
              />,
              "",
              pageType
            )}
          </div>
          <div styleName="login-wrapper" className="print-logo-wrapper">
            <div styleName="bell-button">
              <LoginContainer
                dot={dot}
                toggleNotifications={toggleNotifications}
                showNotifications={showNotifications}
                notifications={notifications}
                showLogin={publisherAttributes.showLogin}
                loginBorderStyle={domainStyle.loginBorder}
                loginTextStyle={domainStyle.loginText}
                bellIconStyle={domainStyle.bellIcon}
                showNotification={showNotification}
              />
            </div>

            <Dropdown label={`${staticTexts(publisherAttributes.lang).edition}:`} list={listValue} />
          </div>
        </div>
        {isDesktop && (
          <div styleName="navbar" className="navbar-wrapper">
            <Navbar
              menu={homePageMenuItems.slice(0, 12)}
              lang={publisherAttributes.lang}
              dataTagCategory="Header Menu"
            />
          </div>
        )}
      </Headroom>
    </div>
  );
};

StaticHeader.propTypes = {
  toggleVerticalMenubar: func,
  isVerticalMenubar: bool,
  dot: bool,
  notifications: array,
  location: string,
  originalLocation: string,
  getIsDesktop: bool,
  domainSlug: string,
  publisherAttributes: object,
  domainMenuItemsObj: array,
  toggleNotifications: func,
  showNotifications: bool,
  pageType: string,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  domainMenuItemsObj: get(state, ["qt", "data", "navigationMenu", "menuItems"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  pageType: get(state, ["qt", "pageType"], ""),
});

export default connect(mapStateToProps, null)(StaticHeader);
